import { render, staticRenderFns } from "./SupplierGalleryImagePicker.vue?vue&type=template&id=bdb84e2a&scoped=true&"
import script from "./SupplierGalleryImagePicker.vue?vue&type=script&lang=js&"
export * from "./SupplierGalleryImagePicker.vue?vue&type=script&lang=js&"
import style0 from "./SupplierGalleryImagePicker.vue?vue&type=style&index=0&id=bdb84e2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb84e2a",
  null
  
)

export default component.exports